import { CampaignOptimizationValue, Micros } from './common.models';

export const CLICKS = 'clicks';
export const CONVERSIONS = 'conversions';
export const IMPRESSIONS = 'impressions';
export const COST = 'cost';
export const REVENUE = 'revenue';
export const PRICE = 'price';
export const PROFIT = 'profit';
export const PROFIT_NET = 'profit_net';
export const PROFIT_NET_ADJUSTED = 'profit_net_adjusted';
export const PROFIT_GROSS = 'profit_gross';
export const PROFIT_GROSS_ADJUSTED = 'profit_gross_adjusted';

export const CLICK_THROUGH_RATE = 'click_through_rate';
export const CONVERSION_RATE = 'conversion_rate';
export const COST_PER_CONVERSION = 'cost_per_conversion';
export const COST_PER_CLICK = 'cost_per_click'; // eCPC
export const COST_REVENUE_RATIO = 'cost_revenue_ratio'; // also called ACoS
export const COST_FOR_REVENUE = 'cost_for_revenue';
export const COST_FOR_PROFIT = 'cost_for_profit';
export const COST_FOR_CLICK = 'cost_for_click';
export const COST_FOR_VCPM = 'cost_for_vcpm';
export const RETURN_ON_INVESTMENT = 'return_on_investment';
export const ROAS = 'return_on_ad_spend';

export const CONVERSIONS_ADJUSTED = 'conversions_adjusted';
export const PROFIT_ADJUSTED = 'profit_adjusted';
export const REVENUE_ADJUSTED = 'revenue_adjusted';
export const COST_PER_CONVERSION_ADJUSTED = 'cost_per_conversion_adjusted';
export const CONVERSION_RATE_ADJUSTED = 'conversion_rate_adjusted';
export const RETURN_ON_INVESTMENT_ADJUSTED = 'return_on_investment_adjusted';
export const COST_REVENUE_RATIO_ADJUSTED = 'cost_revenue_ratio_adjusted';
export const ROAS_ADJUSTED = 'return_on_ad_spend_adjusted';
export const REVENUE_PER_CONVERSION = 'revenue_per_conversion';
export const CRITERION_MAX_CPC = 'criterion_max_cpc';
export const TOS_IMPRESSION_SHARE = 'tos_impression_share';
export const MAX_BID = 'max_bid';
export const MIN_BID = 'min_bid';

export const REVENUE_TOTAL = 'revenue_total';
export const REVENUE_TOTAL_ROLLING_AVG = 'revenue_total_rolling_avg';
export const REVENUE_ORGANIC = 'revenue_organic';
export const REVENUE_ORGANIC_ADJUSTED = 'revenue_organic_adjusted';
export const REVENUE_ORGANIC_ROLLING_AVG = 'revenue_rolling_avg';
export const COST_REVENUE_TOTAL_RATIO = 'cost_revenue_total_ratio';
export const COST_REVENUE_TOTAL_RATIO_ROLLING_AVG = 'cost_revenue_total_ratio_rolling_avg';

export const VIEW_IMPRESSIONS = 'view_impressions';
export const CONVERSIONS_CLICKS = 'conversions_clicks';
export const CONVERSION_RATE_CLICKS = 'conversion_rate_clicks';
export const REVENUE_CLICKS = 'revenue_clicks';
export const ROAS_CLICKS = 'return_on_ad_spend_clicks';
export const COST_REVENUE_RATIO_CLICKS = 'cost_revenue_ratio_clicks';
export const CLICK_THROUGH_RATE_CLICKS = 'click_through_rate_clicks';
export const COST_PER_CONVERSION_CLICKS = 'cost_per_conversion_clicks';

export const IMPRESSIONS_TOTAL = 'impressions_total';
export const COST_PER_MILLE = 'cost_per_m_view_impressions';

export const COST_DAY = 'cost_day';
export const COST_TOTAL = 'cost_total'; // this is not metric from backend, this is for frontend only
export const REVENUE_DAY = 'revenue_day';
export const IMPRESSION_DAY = 'impression_day';
export const CLICK_DAY = 'click_day';
export const PROFIT_DAY = 'profit_day';
export const CONVERSION_DAY = 'conv_day';

export const CONVERSION_CLICKS_DAY = 'conv_clicks_day';
export const REVENUE_CLICKS_DAY = 'revenue_clicks_day';

export const COST_MONTH = 'cost_month';
export const CLICK_MONTH = 'click_month';

export const PG_GOAL_METRIC_CLICKS_PER_DAY = 'CLICKS-PER-DAY';
export const PG_GOAL_METRIC_COST_PER_CLICK = 'COST-PER-CLICK';
export const PG_GOAL_METRIC_COST_PER_CONVERSION = 'COST-PER-CONVERSION';
export const PG_GOAL_METRIC_COST_PER_DAY = 'COST-PER-DAY';
export const PG_GOAL_METRIC_CRR = 'CRR';
export const PG_GOAL_METRIC_PROFIT_MAXIMIZATION = 'PROFIT-MAXIMIZATION';
export const PG_GOAL_METRIC_ROAS = 'ROAS';
export const PG_GOAL_METRIC_ROI = 'ROI';
export const PG_GOAL_METRIC_ROAS_CLICKS = 'ROAS_CLICKS';
export const PG_GOAL_METRIC_CRR_CLICKS = 'CRR_CLICKS';
export const PG_GOAL_METRIC_COST_PER_CONVERSION_CLICKS = 'COST-PER-CONVERSION_CLICKS';

export const PG_GOAL_METRIC_CLICKS_PER_MONTH = 'CLICKS-PER-MONTH';
export const PG_GOAL_METRIC_CONVERSIONS_PER_MONTH = 'CONVERSIONS-PER-MONTH';
export const PG_GOAL_METRIC_COST_PER_MONTH = 'COST-PER-MONTH';

export const AMZ_PRODUCT_ADS_MATCH_RATIO = 'amz_product_ads_match_ratio';

export const MIN_DEFAULT_COST_DAY_GOAL_VALUE = 1e5;

export const BUDGET_SUGGESTED_ACCOUNT_CURRENCY_VALUE = 'budget_suggested_account_currency';
export const BUDGET_CURRENT_ACCOUNT_CURRENCY_VALUE = 'budget_current_account_currency';
export const BUDGET_APPROVED_ACCOUNT_CURRENCY_VALUE = 'budget_approved_account_currency';
export const BUDGET_SUGGESTED_CUSTOMER_CURRENCY_VALUE = 'budget_suggested_customer_currency';
export const BUDGET_CURRENT_CUSTOMER_CURRENCY_VALUE = 'budget_current_customer_currency';
export const BUDGET_APPROVED_CUSTOMER_CURRENCY_VALUE = 'budget_approved_customer_currency';
export const BUDGET_ESTD_OPTIMAL_SPENDING = 'budget_est_optimal_spending';
export const AVG_COST_7 = 'avg_cost_7';
export const AVG_COVERAGE_7 = 'avg_coverage_7';
export const BUDGET_USAGE_7 = 'avg_usage_7';

export const ADDED_CRITERIA_CONVERSIONS = 'added_criteria_conversions';
export const BUDGET_COVERAGE = 'budget_coverage';
export const BUDGET_AMOUNT = 'budget_amount';

export type AllGoalTypes =
  | typeof PG_GOAL_METRIC_CLICKS_PER_DAY
  | typeof PG_GOAL_METRIC_COST_PER_CLICK
  | typeof PG_GOAL_METRIC_COST_PER_CONVERSION
  | typeof PG_GOAL_METRIC_COST_PER_CONVERSION_CLICKS
  | typeof PG_GOAL_METRIC_COST_PER_DAY
  | typeof PG_GOAL_METRIC_CRR
  | typeof PG_GOAL_METRIC_CRR_CLICKS
  | typeof PG_GOAL_METRIC_PROFIT_MAXIMIZATION
  | typeof PG_GOAL_METRIC_ROAS
  | typeof PG_GOAL_METRIC_ROAS_CLICKS
  | typeof PG_GOAL_METRIC_CLICKS_PER_MONTH
  | typeof PG_GOAL_METRIC_CONVERSIONS_PER_MONTH
  | typeof PG_GOAL_METRIC_COST_PER_MONTH
  | typeof PG_GOAL_METRIC_ROI;

export type AllMetrics =
  | typeof VIEW_IMPRESSIONS
  | typeof COST_PER_MILLE
  | typeof CLICK_THROUGH_RATE_CLICKS
  | typeof COST_REVENUE_RATIO_CLICKS
  | typeof CONVERSION_RATE_CLICKS
  | typeof ROAS_CLICKS
  | typeof CLICKS
  | typeof CONVERSIONS
  | typeof CONVERSIONS_CLICKS
  | typeof IMPRESSIONS
  | typeof COST
  | typeof COST_TOTAL
  | typeof COST_DAY
  | typeof REVENUE
  | typeof REVENUE_CLICKS
  | typeof PRICE
  | typeof PROFIT
  | typeof PROFIT_NET
  | typeof PROFIT_GROSS
  | typeof PROFIT_GROSS_ADJUSTED
  | typeof CLICK_THROUGH_RATE
  | typeof CONVERSION_RATE
  | typeof COST_PER_CONVERSION
  | typeof COST_PER_CONVERSION_CLICKS
  | typeof COST_PER_CLICK
  | typeof COST_REVENUE_RATIO
  | typeof CRITERION_MAX_CPC
  | typeof RETURN_ON_INVESTMENT
  | typeof ROAS
  | typeof CONVERSIONS_ADJUSTED
  | typeof PROFIT_ADJUSTED
  | typeof REVENUE_ADJUSTED
  | typeof COST_PER_CONVERSION_ADJUSTED
  | typeof CONVERSION_RATE_ADJUSTED
  | typeof RETURN_ON_INVESTMENT_ADJUSTED
  | typeof COST_REVENUE_RATIO_ADJUSTED
  | typeof ROAS_ADJUSTED
  | typeof COST_FOR_REVENUE
  | typeof COST_FOR_PROFIT
  | typeof COST_FOR_VCPM
  | typeof COST_FOR_CLICK
  | typeof REVENUE_ORGANIC
  | typeof REVENUE_ORGANIC_ADJUSTED
  | typeof REVENUE_ORGANIC_ROLLING_AVG
  | typeof COST_REVENUE_TOTAL_RATIO
  | typeof COST_REVENUE_TOTAL_RATIO_ROLLING_AVG
  | typeof REVENUE_TOTAL
  | typeof REVENUE_TOTAL_ROLLING_AVG
  | typeof COST_DAY
  | typeof COST_TOTAL
  | typeof REVENUE_DAY
  | typeof IMPRESSION_DAY
  | typeof CLICK_DAY
  | typeof PROFIT_DAY
  | typeof CONVERSION_DAY
  | typeof REVENUE_CLICKS_DAY
  | typeof CONVERSION_CLICKS_DAY
  | typeof COST_MONTH
  | typeof CLICK_MONTH
  | typeof PG_GOAL_METRIC_CLICKS_PER_DAY
  | typeof PG_GOAL_METRIC_COST_PER_CLICK
  | typeof PG_GOAL_METRIC_COST_PER_CONVERSION
  | typeof PG_GOAL_METRIC_COST_PER_CONVERSION_CLICKS
  | typeof PG_GOAL_METRIC_COST_PER_DAY
  | typeof PG_GOAL_METRIC_CRR
  | typeof PG_GOAL_METRIC_CRR_CLICKS
  | typeof PG_GOAL_METRIC_PROFIT_MAXIMIZATION
  | typeof PG_GOAL_METRIC_ROAS
  | typeof PG_GOAL_METRIC_ROAS_CLICKS
  | typeof PG_GOAL_METRIC_CLICKS_PER_MONTH
  | typeof PG_GOAL_METRIC_CONVERSIONS_PER_MONTH
  | typeof PG_GOAL_METRIC_COST_PER_MONTH
  | typeof PG_GOAL_METRIC_ROI
  | typeof REVENUE_PER_CONVERSION
  | typeof MAX_BID
  | typeof MIN_BID
  | typeof BUDGET_SUGGESTED_ACCOUNT_CURRENCY_VALUE
  | typeof BUDGET_APPROVED_ACCOUNT_CURRENCY_VALUE
  | typeof BUDGET_CURRENT_ACCOUNT_CURRENCY_VALUE
  | typeof BUDGET_SUGGESTED_CUSTOMER_CURRENCY_VALUE
  | typeof BUDGET_CURRENT_CUSTOMER_CURRENCY_VALUE
  | typeof BUDGET_APPROVED_CUSTOMER_CURRENCY_VALUE
  | typeof BUDGET_ESTD_OPTIMAL_SPENDING
  | typeof AVG_COST_7
  | typeof AVG_COVERAGE_7
  | typeof BUDGET_USAGE_7
  | typeof BUDGET_COVERAGE
  | typeof BUDGET_AMOUNT;

export type MetricKeyValue = Record<AllMetrics, number | Micros | null>;

export const percentMetrics = [
  CONVERSION_RATE,
  CONVERSION_RATE_ADJUSTED,
  CLICK_THROUGH_RATE,
  COST_REVENUE_RATIO,
  COST_REVENUE_RATIO_ADJUSTED,
  PG_GOAL_METRIC_CRR,
  PG_GOAL_METRIC_CRR_CLICKS,
  COST_REVENUE_TOTAL_RATIO,
  COST_REVENUE_TOTAL_RATIO_ROLLING_AVG,
  AMZ_PRODUCT_ADS_MATCH_RATIO,
  AVG_COVERAGE_7,
  BUDGET_USAGE_7,
  BUDGET_COVERAGE,
  CONVERSION_RATE_CLICKS,
  CLICK_THROUGH_RATE_CLICKS,
  COST_REVENUE_RATIO_CLICKS,
  TOS_IMPRESSION_SHARE,
];
export const currencyMetrics = [
  PRICE,
  PROFIT,
  PROFIT_ADJUSTED,
  PROFIT_NET,
  PROFIT_NET_ADJUSTED,
  PROFIT_GROSS,
  PROFIT_GROSS_ADJUSTED,
  REVENUE,
  REVENUE_ADJUSTED,
  COST,
  COST_PER_CLICK,
  COST_FOR_CLICK,
  COST_FOR_REVENUE,
  COST_FOR_PROFIT,
  COST_FOR_VCPM,
  COST_PER_CONVERSION,
  COST_PER_CONVERSION_CLICKS,
  COST_PER_CONVERSION_ADJUSTED,
  REVENUE_ORGANIC,
  REVENUE_ORGANIC_ADJUSTED,
  REVENUE_ORGANIC_ROLLING_AVG,
  REVENUE_PER_CONVERSION,
  REVENUE_TOTAL,
  REVENUE_TOTAL_ROLLING_AVG,
  COST_DAY,
  COST_TOTAL,
  COST_MONTH,
  REVENUE_DAY,
  REVENUE_CLICKS_DAY,
  PROFIT_DAY,
  CRITERION_MAX_CPC,
  MAX_BID,
  MIN_BID,
  PG_GOAL_METRIC_PROFIT_MAXIMIZATION,
  PG_GOAL_METRIC_COST_PER_DAY,
  PG_GOAL_METRIC_COST_PER_MONTH,
  PG_GOAL_METRIC_COST_PER_CLICK,
  PG_GOAL_METRIC_COST_PER_CONVERSION,
  PG_GOAL_METRIC_COST_PER_CONVERSION_CLICKS,
  BUDGET_SUGGESTED_ACCOUNT_CURRENCY_VALUE,
  BUDGET_APPROVED_ACCOUNT_CURRENCY_VALUE,
  BUDGET_CURRENT_ACCOUNT_CURRENCY_VALUE,
  BUDGET_SUGGESTED_CUSTOMER_CURRENCY_VALUE,
  BUDGET_CURRENT_CUSTOMER_CURRENCY_VALUE,
  BUDGET_APPROVED_CUSTOMER_CURRENCY_VALUE,
  BUDGET_ESTD_OPTIMAL_SPENDING,
  AVG_COST_7,
  BUDGET_AMOUNT,
  REVENUE_CLICKS,
  COST_PER_MILLE,
];

export const numberMetrics = [
  IMPRESSION_DAY,
  CLICK_DAY,
  CONVERSION_DAY,
  CONVERSION_CLICKS_DAY,
  IMPRESSIONS,
  CLICKS,
  CLICK_MONTH,
  CONVERSIONS,
  CONVERSIONS_ADJUSTED,
  ROAS,
  ROAS_ADJUSTED,
  PG_GOAL_METRIC_ROAS,
  PG_GOAL_METRIC_ROAS_CLICKS,
  RETURN_ON_INVESTMENT,
  RETURN_ON_INVESTMENT_ADJUSTED,
  PG_GOAL_METRIC_ROI,
  VIEW_IMPRESSIONS,
  CONVERSIONS_CLICKS,
  ROAS_CLICKS,
];
export const vCPMMetrics = [
  VIEW_IMPRESSIONS,
  COST_PER_MILLE,
  CONVERSIONS_CLICKS,
  CONVERSION_RATE_CLICKS,
  REVENUE_CLICKS,
  ROAS_CLICKS,
  COST_REVENUE_RATIO_CLICKS,
  CLICK_THROUGH_RATE_CLICKS,
  COST_PER_CONVERSION_CLICKS,
];

export const VCPMMetricMaps = {
  [REVENUE_DAY]: REVENUE_CLICKS_DAY,
  [CONVERSION_DAY]: CONVERSION_CLICKS_DAY,
  [CONVERSIONS]: CONVERSIONS_CLICKS,
  [CONVERSION_RATE]: CONVERSION_RATE_CLICKS,
  [REVENUE]: REVENUE_CLICKS,
  [ROAS]: ROAS_CLICKS,
  [COST_REVENUE_RATIO]: COST_REVENUE_RATIO_CLICKS,
  [CLICK_THROUGH_RATE]: CLICK_THROUGH_RATE_CLICKS,
  [COST_PER_CONVERSION]: COST_PER_CONVERSION_CLICKS,
};

export const VCPMGoalMetricMaps = {
  [PG_GOAL_METRIC_ROAS]: PG_GOAL_METRIC_ROAS_CLICKS,
  [PG_GOAL_METRIC_CRR]: PG_GOAL_METRIC_CRR_CLICKS,
  [PG_GOAL_METRIC_COST_PER_CONVERSION]: PG_GOAL_METRIC_COST_PER_CONVERSION_CLICKS,
};

export const AllMetricsArray = [...new Set([...numberMetrics, ...currencyMetrics, ...percentMetrics, ...vCPMMetrics])];

export const percentGoals = [PG_GOAL_METRIC_CRR, PG_GOAL_METRIC_CRR_CLICKS];
export const currencyGoals = [
  PG_GOAL_METRIC_COST_PER_CLICK,
  PG_GOAL_METRIC_COST_PER_CONVERSION,
  PG_GOAL_METRIC_COST_PER_CONVERSION_CLICKS,
  PG_GOAL_METRIC_COST_PER_DAY,
  PG_GOAL_METRIC_COST_PER_MONTH,
];

export const DelayMappedMetrics = {
  [CONVERSIONS]: CONVERSIONS_ADJUSTED,
  [PROFIT_GROSS]: PROFIT_GROSS_ADJUSTED,
  [PROFIT_NET]: PROFIT_NET_ADJUSTED,
  [REVENUE]: REVENUE_ADJUSTED,
  [REVENUE_ORGANIC]: REVENUE_ORGANIC_ADJUSTED,
  [COST_PER_CONVERSION]: COST_PER_CONVERSION_ADJUSTED,
  [CONVERSION_RATE]: CONVERSION_RATE_ADJUSTED,
  [RETURN_ON_INVESTMENT]: RETURN_ON_INVESTMENT_ADJUSTED,
  [COST_REVENUE_RATIO]: COST_REVENUE_RATIO_ADJUSTED,
  [ROAS]: ROAS_ADJUSTED,
  [ADDED_CRITERIA_CONVERSIONS]: 'added_criteria_conversions_adjusted',
};

export const LessThan7DaysMappedMetrics = { [COST_REVENUE_TOTAL_RATIO]: COST_REVENUE_TOTAL_RATIO_ROLLING_AVG };

export const MetricsWithFullNumber = [
  PG_GOAL_METRIC_ROAS,
  PG_GOAL_METRIC_ROAS_CLICKS,
  PG_GOAL_METRIC_ROI,
  ROAS,
  ROAS_ADJUSTED,
  RETURN_ON_INVESTMENT,
  RETURN_ON_INVESTMENT_ADJUSTED,
];

export const TacosMetrics = [REVENUE_TOTAL, REVENUE_ORGANIC, COST_REVENUE_TOTAL_RATIO];

export const costType: Record<CampaignOptimizationValue, AllMetrics> = {
  CLICK: COST_FOR_CLICK,
  PROFIT: COST_FOR_PROFIT,
  REVENUE: COST_FOR_REVENUE,
  VCPM: COST_FOR_REVENUE,
};

export const decreasePositiveMetrics: AllMetrics[] = [
  COST_REVENUE_RATIO,
  COST_PER_CONVERSION,
  COST_PER_CLICK,
  COST,
  COST_DAY,
  COST_TOTAL,
  COST_PER_MILLE,
];

export const CustomerPerfEndpointAllColumns = [
  'date',
  'adspert_account_id',
  'account_id',
  'account_name',
  'account_platform',
  'account_optimize',
  'account_tags_user',
  'account_is_demo',
  'performance_group_id',
  'performance_group_name',
  'performance_group_enabled',
  'performance_group_optimization_type',
  'performance_group_goals',
  'performance_group_goal_types',
  'performance_group_platforms',
  'performance_group_user_max_bid',
  'adspert_portfolio_id',
  'amz_portfolio_id',
  'amz_portfolio_name',
  'campaign_amz_ras_campaign',
  'adspert_campaign_id',
  'campaign_id',
  'campaign_name',
  'campaign_type',
  'campaign_eby_marketplace_id',
  'campaign_status',
  'campaign_optimize',
  'campaign_optimization_type',
  'campaign_optimization_support',
  'campaign_labels',
  'campaign_user_max_bid',
  'impressions',
  'view_impressions',
  'impressions_total',
  'clicks',
  'conversions',
  'conversions_clicks',
  'conversions_adjusted',
  'conversions_for_revenue',
  'conversions_for_revenue_adjusted',
  'profit_gross',
  'profit_gross_adjusted',
  'profit_net',
  'profit_net_adjusted',
  'revenue',
  'revenue_clicks',
  'revenue_adjusted',
  'revenue_total',
  'revenue_total_rolling_avg',
  'revenue_organic',
  'revenue_organic_adjusted',
  'budget_amount',
  'cost',
  'cost_for_profit',
  'cost_for_revenue',
  'cost_for_click',
  'cost_for_vcpm',
  'cost_for_organic',
  'cost_for_organic_rolling_avg',
  'cost_per_click',
  'cost_per_m_view_impressions',
  'cost_per_conversion',
  'cost_per_conversion_clicks',
  'cost_per_conversion_adjusted',
  'conversion_rate',
  'conversion_rate_clicks',
  'conversion_rate_adjusted',
  'click_through_rate',
  'click_through_rate_clicks',
  'return_on_investment',
  'return_on_investment_adjusted',
  'return_on_ad_spend',
  'return_on_ad_spend_clicks',
  'return_on_ad_spend_adjusted',
  'cost_revenue_ratio',
  'cost_revenue_ratio_clicks',
  'cost_revenue_ratio_adjusted',
  'cost_revenue_total_ratio',
  'cost_revenue_total_ratio_rolling_avg',
  'revenue_per_conversion',
  'revenue_per_conversion_adjusted',
  'budget_coverage',
  'has_vcpm',
  'mutate_update_queue',
  'mutate_create_queue',
];
